import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
  container: {
    "&:not(:last-child)": {
      borderBottom: `1px solid ${palette.divider}`
    },
    alignItems: "baseline",
    display: "flex",
    flexWrap: "nowrap",
    padding: `${spacing.unit * 3}px 0`
  }
});

const BaseContainer: React.FC<WithStyles<typeof styles>> = ({ classes, children }) => (
  <div className={classes.container}>{children}</div>
);

export const MainContainer = withStyles(styles)(BaseContainer);
